export default [
  /**
   * 默认登录平台配置
   */
  {
    title: '精彩纵横云采购平台',
    alias: 'default', // 平台别称
    domain: process.env.VUE_APP_DOMAIN.split(','), // 匹配域名
    favicon: './favicon.ico',
    logo: require('@/assets/images/jczh/complete-logo.png'), // 网站logo
    logoHeight: 50,
    loginLogo: require('@/assets/images/jczh/complete-logo-white.png'), // 登录页面的logo
    loginBgImg: require('./assets/images/jczh/background.png'), // 登录页面背景
    needValueAdd: true, // 是否需要增值服务
    theme: ['#1890ff', '#ff4d4f'], // 主题颜色 （涉及Element）
    otherTheme: ['#1890ff', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb'], // 主题衍生色 （不涉及element-ui）
    defaultLoginMethod: 'wechat', // 默认登录方式
    loginUrl: process.env.VUE_APP_LOGIN_URL,
    portalUrl: process.env.VUE_APP_PORTAL_URL
  },

  /**
   * 国资登录平台配置
   */
  {
    title: '江西省国有企业采购交易服务平台',
    alias: 'gz',
    domain: process.env.VUE_APP_GZ_DOMAIN.split(','), // 匹配域名
    favicon: './undefined-favicon.ico',
    logo: require('@/assets/images/gzw/logo.png'), // 网站logo
    logoHeight: 40,
    loginLogo: require('@/assets/images/gzw/logo-white.png'), // 登录页面的logo
    loginBgImg: require('@/assets/images/gzw/background.png'),
    needValueAdd: true,
    theme: ['#005CB8', '#ff4d4f'], // 主题颜色
    otherTheme: ['#005CB8', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb'],
    defaultLoginMethod: 'wechat',
    loginUrl: process.env.VUE_APP_GZ_LOGIN_URL,
    portalUrl: process.env.VUE_APP_GZ_PORTAL_URL
  },

  /**
   * 省投登录平台配置
   */
  {
    title: '江西投资集团电子采购平台',
    alias: 'jxic',
    domain: process.env.VUE_APP_JXIC_DOMAIN.split(','),
    favicon: './jxic-favicon.ico',
    logo: require('@/assets/images/jxic/logo.png'), // 网站logo
    logoHeight: 50,
    loginLogo: require('@/assets/images/jxic/logo-white.png'), // 登录页面的logo
    loginBgImg: require('@/assets/images/jxic/background.png'),
    needValueAdd: false,
    theme: ['#E36C09', '#ff4d4f'], // 主题颜色
    otherTheme: ['#E36C09', '#FDC494', '#FFECDB', '#FFF4EB', '#F8F8F8'],
    defaultLoginMethod: 'account',
    loginUrl: process.env.VUE_APP_JXIC_LOGIN_URL,
    portalUrl: process.env.VUE_APP_JXIC_PORTAL_URL
  },

  /**
   * 新钢登录平台配置
   */
  {
    title: '新钢集团数字采购平台',
    alias: 'xin-steel',
    domain: process.env.VUE_APP_XIN_STEEL_DOMAIN.split(','),
    favicon: './xin-steel-favicon.ico',
    logo: require('@/assets/images/xin-steel/logo.png'), // 网站logo
    logoHeight: 50,
    loginLogo: require('@/assets/images/xin-steel/logo.png'), // 登录页面的logo
    loginBgImg: require('@/assets/images/xin-steel/background.png'),
    needValueAdd: false,
    theme: ['#226CFD', '#ff4d4f'], // 主题颜色
    otherTheme: ['#226CFD', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb'], // 主题衍生色 （不涉及element-ui）
    defaultLoginMethod: 'account',
    loginUrl: process.env.VUE_APP_XIN_STEEL_LOGIN_URL,
    portalUrl: process.env.VUE_APP_XIN_STEEL_PORTAL_URL
  }
]
